module.exports = __webpack_public_path__ + "static/media/ic_dustbin_selected.a594632f.svg";